import { Injectable } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
var JSZip = require('jszip');

var pdfMake = require('pdfmake/build/pdfmake.js');
var pdfFonts = require('pdfmake/build/vfs_fonts.js');

@Injectable()
export class CreatePdfService {

  public df: any;
  constructor(private currencyPipe: CurrencyPipe) {
    this.df = {};
  }

  public generateReports2(data) {
    const p = new Promise<any[]>(async (resolve, reject) => {
      const listPdf: any[] = [];
      await data.forEach(async (item) => {
        const report = Object.create(item.xml_reporte);
        await this.getTemplate(report.header, report.body, report.Impuesto, report.footer, report.resolucion).then(
          async (template) => {
            let pdf = {};
            pdf['filename'] = `${report['header'].numero}.pdf`;
            pdf['data'] = await this.createPDF(template).then(
              (response) => {
                listPdf.push(response);
              }
            );
          }
        );

      });
      resolve(listPdf);
    });
    return p;
  }

  public async generateReports(data: any[]): Promise<any[]> {
    const listPdf: any[] = [];
 
    for (const item of data) {
      const report = item.xml_reporte;

      await this.getTemplate(report.header, report.body, report.Impuesto, report.footer,  report['resolucion']).then(
        async (template) => {
          let pdf = {};
          pdf['filename'] = `${report['header'].numero}.pdf`;
          await this.createPDF(template).then(
            (response) => {
              pdf['data'] = response;
              listPdf.push(pdf);
            }
          );
        }
      );
    }
 
 
    return listPdf;
  }

  public getTemplate(header: any, body: any[], impuesto: any[], notas:any, resolucion:any) {
    const p = new Promise<any>((resolved, reject) => {
      const headerBody = ['línea', 'description', 'cantidad', 'valor_unitario', 'total_línea'];
      const headerImpuesto = ['impuesto', 'line_description', 'valor_base', 'tasa', 'total_impuesto'];
      const dd = {
        pageSize: 'A4',
        pageMargins: [15, 290, 15, 230],
        header: {
          margin: [15, 10, 15, 10],
          columns: [
              [
                  {
                      table: {
                          widths: [ '60%','40%'],
                          body: [
                              [
                                  { 
                                      border: [false, false, false, false],
                                      columns:[
                                        this.headerDinamic(header)
                                      ],
                                  },
                                
                                  {
                                      margin: 10,
                                      border: [false, false, false, false],
                                      bold: true,
                                      columns:[
                                          [
                                              
                                              {
                                                  text: 'DOCUMENTO SOPORTE EN ADQUISICIONES',
                                                  fontSize: 10,
                                              },
                                              {
                                                  text: 'EFECTUADOS A NO OBLIGADOS A FACTURAR',
                                                  noWrap: false,
                                                  fontSize: 10,
                                              },
                                              {
                                                  text: `Consecutivo: ${header.numero}`,
                                                  margin: [0,70,0,0],
                                                  bold: false,
                                              },
                                              {
                                                  text: `Fecha Emisión: ${header.fecha}`,
                                                  bold: false,
                                              },
                                              // {
                                              //   canvas: [
                                              //     {
                                              //       type: 'rect',
                                              //       x: -3,
                                              //       y: -93,
                                              //       w: 220,
                                              //       h: 105,
                                              //       r: 5,
                                              //       lineColor: 'black',
                                              //     },
                                              //   ]
                                              // }
                                              
                                          ]
                                         
                                      ]
                                   
                                  
                                  }
                                
                              ]
  
                              
                          ]
                      },
                      alignment: 'center',
                      fontSize: 8,
                  },
                  {
                      margin: [0, 10, 0, 0],
                      table: {
                          widths: [ '50%','50%'],
                          body: [
                              [
                                  {
                                      margin: [0, 0, 0, 0],
                                      border: [false, false, false, false],
                                      columns: [
                                          {
                                              // auto-sized columns have their widths based on their content
                                              width: 'auto',
                                              text: 'Proveedor:',
                                              bold: true,
                                          },
                                          {
                                              // auto-sized columns have their widths based on their content
                                              width: 'auto',
                                              text: header.proveedor,
                                          },
                                      ]
                                  },
                                  {
                                      margin: [0, 0, 0, 0],
                                      border: [false, false, false, false],
                                      columns: [
                                          {
                                              // auto-sized columns have their widths based on their content
                                              width: 'auto',
                                              text: 'Documento Interno:',
                                              bold: true,
                                          },
                                          {
                                              // auto-sized columns have their widths based on their content
                                              width: 'auto',
                                              text: header.factura
                                          },
                                      ]
                                  },
                              ],
                              [
                                  {
                                      margin: [0, 0, 0, 0],
                                      border: [false, false, false, false],
                                      columns: [
                                          {
                                              // auto-sized columns have their widths based on their content
                                              width: 'auto',
                                              text: 'Nit:',
                                              bold: true,
                                          },
                                          {
                                              // auto-sized columns have their widths based on their content
                                              width: 'auto',
                                              text: header.nit,
                                          },
                                      ]
                                  },
                                  {
                                        margin: [0, 0, 0, 0],
                                        border: [false, false, false, false],
                                        columns: [
                                            {
                                                // auto-sized columns have their widths based on their content
                                                width: 'auto',
                                                text: 'Fecha Operación:',
                                                bold: true,
                                            },
                                            {
                                                // auto-sized columns have their widths based on their content
                                                width: 'auto',
                                                text: header.fecha_factura,
                                            },
                                        ]
                                  },
                                  
                              ],
                              [
                                  {
                                      margin: [0, 0, 0, 0],
                                      border: [false, false, false, false],
                                      columns: [
                                          {
                                              // auto-sized columns have their widths based on their content
                                              width: 'auto',
                                              text: 'Dirección:',
                                              bold: true,
                                          },
                                          {
                                              // auto-sized columns have their widths based on their content
                                              width: 'auto',
                                              text: header.direccion,
                                          },
                                      ]
                                  },
                                  {
                                      margin: [0, 0, 0, 0],
                                      border: [false, false, false, false],
                                      columns: [
                                          {
                                              // auto-sized columns have their widths based on their content
                                              width: 'auto',
                                              text: 'Forma de Pago:',
                                              bold: true,
                                          },
                                          {
                                              // auto-sized columns have their widths based on their content
                                              width: 'auto',
                                              text: header.forma_de_pago,
                                          },
                                      ]
                                  },
                                 
                              ],
                              [
                                  {
                                      margin: [0, 0, 0, 0],
                                      border: [false, false, false, false],
                                      columns: [
                                          {
                                              // auto-sized columns have their widths based on their content
                                              width: 'auto',
                                              text: 'Ciudad:',
                                              bold: true,
                                          },
                                          {
                                              // auto-sized columns have their widths based on their content
                                              width: 'auto',
                                              text: header.ciudad,
                                          },
                                      ]
                                  },
                                  {
                                    margin: [0, 0, 0, 0],
                                    border: [false, false, false, false],
                                    columns: [
                                        {
                                            // auto-sized columns have their widths based on their content
                                            width: 'auto',
                                            text: 'Fecha de Vencimiento:',
                                            bold: true,
                                        },
                                        {
                                            // auto-sized columns have their widths based on their content
                                            width: 'auto',
                                            text: header.fecha_vencimiento,
                                        },
                                    ]
                                },
                              ],
                              [
                                {
                                  margin: [0, 0, 0, 0],
                                  border: [false, false, false, false],
                                  columns: [
                                      {
                                          // auto-sized columns have their widths based on their content
                                          width: 'auto',
                                          text: '',
                                          bold: true,
                                      },
                                      {
                                          // auto-sized columns have their widths based on their content
                                          width: 'auto',
                                          text: '',
                                          alignment: 'left',
                                      },
                                  ]
                                },
                                {
                                  margin: [0, 0, 0, 0],
                                  border: [false, false, false, false],
                                  columns: [
                                      {
                                          // auto-sized columns have their widths based on their content
                                          width: 'auto',
                                          text: 'Moneda: ',
                                          bold: true,
                                      },
                                      {
                                          // auto-sized columns have their widths based on their content
                                          width: 'auto',
                                          text: header.moneda,
                                          alignment: 'left',
                                      },
                                  ]
                                },
                              ]
      
                              
                          ]
                      },
                      alignment: 'center',
                      fontSize: 8,
                  },
                  // {
                      
                  //     canvas: [
                  //         {
                  //             type: 'rect',
                  //             x: 0,
                  //             y: -89,
                  //             w: 575,
                  //             h: 90,
                  //             r: 5,
                  //             lineColor: 'black',
                  //         },
                  //     ]
  
                  // }
              ]
  
          ]
        },
        content: [
          this.tableBody(body, headerBody),
          this.tableImpuesto(impuesto, headerImpuesto),
        ],
        footer: {
          margin: [15,10,15,10],
          columns: [
              [
                  // {
                  //     table: {
                  //         widths: [ '50%','50%'],
                  //         body: [
                  //             [
                  //                 { 
                  //                     // border: [false, false, false, false],
                  //                     columns:[
                  //                         [
                  //                             {
                  //                                 text: 'Notas:'
                  //                             },
                  //                             {
                  //                                 margin:[0,0,5,5],
                  //                                 alignment:'justify',
                  //                                 text: `${notas.notas}`
                  //                             },
                  //                             {
                  //                               // canvas: [
                  //                               //   {
                  //                               //     type: 'rect',
                  //                               //     x: -5,
                  //                               //     y: -30,
                  //                               //     w: 290,
                  //                               //     h: 70,
                  //                               //     r: 5,
                  //                               //     lineColor: 'black',
                  //                               //   },
                  //                               // ]
                  //                             }
                  //                         ]
                  //                     ],
                  //                 },
                                
                  //                 {
                  //                     // border: [false, false, false, false],
                  //                     margin:[0, 0, 0, 0],
                  //                     columns:[
                  //                         [
                                              
                  //                             {
                                                 
                  //                                     table: {
                  //                                       widths: ['50%', '25%', '25%'],
                  //                                       body: [
                  //                                         [
                  //                                             {
                  //                                                 text: 'Subtotal:',
                  //                                                 style: 'tableHeader', alignment: 'right',
                  //                                                 // border: [false, false, true, false],
                  //                                                 fillColor: '#eeeeee',
                  //                                                 bold: true
                                                                  
                  //                                             },
                  //                                             {
                  //                                                 text: (notas.subtotal) ?  this.currencyPipe.transform(notas.subtotal)  : notas.subtotal,
                  //                                                 alignment: 'right',
                  //                                                 // border: [false, false, false, false],
                  //                                             }
                  //                                         ],
                  //                                          [
                  //                                             {
                  //                                                 text: 'Impuesto',
                  //                                                 style: 'tableHeader', alignment: 'right',
                  //                                                 // border: [false, true, true, false],
                  //                                                 fillColor: '#eeeeee',
                  //                                                 bold: true
                                                                  
                  //                                             },
                  //                                             {
                  //                                                 text: (notas.impuesto)  ?  this.currencyPipe.transform(notas.impuesto)  : notas.impuesto,
                  //                                                 style: 'tableHeader',
                  //                                                 alignment: 'right',
                  //                                                 // border: [false, true, false, false],
                  //                                             }
                  //                                          ],
                  //                                          [
                  //                                             {
                  //                                                 text: 'Retenciones',
                  //                                                 style: '', alignment: 'right',
                  //                                                 // border: [false, true, true, false],
                  //                                                 fillColor: '#eeeeee',
                  //                                                 bold: true
                                                                  
                  //                                             },
                  //                                             {
                  //                                                 text: (notas.retencion)  ?  this.currencyPipe.transform(notas.retencion)  : notas.retencion,
                  //                                                 style: 'tableHeader',
                  //                                                 alignment: 'right',
                  //                                                 // border: [false, true, false, false],
                  //                                             }
                  //                                          ],
                  //                                          [
                  //                                             {
                  //                                                 text: 'Total',
                  //                                                 alignment: 'right',
                  //                                                 // border: [false, true, true, false],
                  //                                                 fillColor: '#eeeeee',
                  //                                                 bold: true 
                                                                  
                  //                                             },
                  //                                             {
                  //                                                 text: (notas.total) ?  this.currencyPipe.transform(notas.total)  : notas.total ,
                  //                                                 style: 'tableHeader',
                  //                                                 alignment: 'right',
                  //                                                 // border: [false, true, false, false],
                                                                  
                  //                                             }
                  //                                          ],
                  //                                       ]
                  //                                     }
                                                      
                                                  
                  //                             },
                  //                             // {
                  //                             //   canvas: [
                  //                             //     {
                  //                             //       type: 'rect',
                  //                             //       x: 1,
                  //                             //       y: -69,
                  //                             //       w: 282,
                  //                             //       h: 70,
                  //                             //       r: 5,
                  //                             //       lineColor: 'black',
                  //                             //     },
                  //                             //   ]
                  //                             // }
  
                                              
                  //                         ]
                                         
                  //                     ]
                                   
                                  
                  //                 }
                                
                  //             ]
  
                              
                  //         ]
                  //     },
                  //     alignment: 'left',
                  //     fontSize: 8,
                  // },

                  {
                    fontSize: 8,
                    table: {
                      widths: ['50%', '25%', '25%'],
                      body: [
                        [
                            {
                                rowSpan: 4,
                                text: `Notas: ${notas.notas}`,
                                alignment:'justify',
                                
                            }, 
                            {
                              text: 'Subtotal',
                              style: 'tableHeader', 
                              alignment: 'right',
                              bold: true
                            }, 
                            {
                              text: (notas.subtotal) ?  this.currencyPipe.transform(notas.subtotal)  : notas.subtotal,
                              alignment: 'right'
                            }
                        ],
                        [
                          {
                            text: ''
                          },  
                          {
                            text: 'Impuesto',
                            style: 'tableHeader', 
                            alignment: 'right',
                            bold: true
                          }, 
                          {
                            text: (notas.impuesto)  ?  this.currencyPipe.transform(notas.impuesto)  : notas.impuesto,
                            style: 'tableHeader',
                            alignment: 'right',
                          }
                        ],
                        [
                          {
                            text: ''
                          },  
                          {
                            text: 'Retenciones',
                            style: 'tableHeader', 
                            alignment: 'right',
                            bold: true
                          }, 
                          {
                            text: (notas.retencion)  ?  this.currencyPipe.transform(notas.retencion)  : notas.retencion,
                            style: 'tableHeader',
                            alignment: 'right',
                          }
                        ],
                        [
                          {
                            text: ''
                          },  
                          {
                            text: 'Total',
                            style: 'tableHeader', 
                            alignment: 'right',
                            bold: true
                          }, 
                          {
                            text: (notas.total) ?  this.currencyPipe.transform(notas.total)  : notas.total ,
                            style: 'tableHeader',
                            alignment: 'right',
                          }
                        ],
              
                      ]
                    }
                  },
                  {
                      border: [true, true, true, true],
                      margin:[5,15,10,5],
                      alignment: 'justify',
                      text: notas.valor_en_letras,
                      fontSize: 8
                  },
                  {
                      canvas: [
                          {
                              type: 'rect',
                              x: 0,
                              y: -25,
                              w: 565,
                              h: 50,
                              r: 0,
                              lineColor: 'black',
                          },
                      ]
                  
                                          
                  },
                  {
                      margin:[5,15,10,5],
                      alignment: 'left',
                      text: (resolucion)? resolucion.textresol: null,
                      fontSize: 8
                  },
                  {
                      canvas: [
                          {
                              type: 'rect',
                              x: 0,
                              y: -30,
                              w: 565,
                              h: 50,
                              r: 0,
                              lineColor: 'black',
                          },
                      ]
                  
                                          
                  }
              ]
          ]
      },
        
      };

      resolved(dd);
    });
    return p;
  }

  public createPDF(dd) {

    const p = new Promise((resolve, reject) => {
      pdfMake.createPdf(dd).getBlob((data) => {
        resolve(data);
      });
    });
    return p;
  }
  
  public getBase64PDF(dd) {

    const p = new Promise((resolve, reject) => {
      pdfMake.createPdf(dd).getBase64((data) => {
        resolve(data);
      });
    });
    return p;
  }

  public openPDF(dd) {
      pdfMake.createPdf(dd).open();
  }

  public buildTableBody(data: any[], columns) {
    const body = [];
    const headerBody = [
      { text: 'Línea', bold: true },
      { text: 'Descripción', bold: true },
      { text: 'Cantidad', bold: true },
      { text: 'Valor Unitario', bold: true },
      { text: 'Total Línea', bold: true }
    ];
    body.push(headerBody);
    if (data) {
      data.forEach((row, index) => {
        row['description'] = {text: row['description'], alignment: 'left'}
        row['total_linea'] = (row.total_linea) ? {text: this.currencyPipe.transform(row.total_linea), alignment: 'right'}  : null;
        row['valor_unitario'] = (row.valor_unitario) ? {text: this.currencyPipe.transform(row.valor_unitario) , alignment: 'right'} : null;
        body.push(Object.values(row));
      });
    }
    return body;
  }

  public buildTableImpuesto(data: any[], columns) {
    const body = [];
    const headerBody = [
      { text: 'Impuestos/Retenciones', bold: true },
      { text: 'Descripción', bold: true },
      { text: 'Valor Base', bold: true },
      { text: 'Tasa', bold: true },
      { text: 'Total Imp/Ret.', bold: true }
    ];
    body.push(headerBody);
    if (data) {
      data.forEach((row, index) => {
        row['impuesto'] = {text: row['impuesto'], alignment: 'left'}
        row['line_description'] = {text: row['line_description'], alignment: 'left'}
        row['tasa'] = {text: row['tasa'], alignment: 'right'}
        row['total_impuesto'] = (row.total_impuesto) ? { text: this.currencyPipe.transform(row.total_impuesto), alignment: 'right' }  : null;
        row['valor_base'] = (row.valor_base) ? {text: this.currencyPipe.transform(row.valor_base), alignment: 'right'}  : null;
        body.push(Object.values(row));
      });
   }
    return body;
  }

  public tableBody(data, columns){

    return {
      table: {
        headerRows: 1,
        widths: [ '5%', '55%', '10%', '15%', '15%' ],
        body: this.buildTableBody(data, columns)
      },
      margin: [0, 0, 0, 10],
      fontSize: 8,
      alignment: 'center'
    };
  }
  public tableImpuesto(data, columns) {

    return {
      table: {
        headerRows: 1,
        widths: [ '25%', '35%', '15%', '10%', '15%' ],
        body: this.buildTableImpuesto(data, columns)
      },
      fontSize: 8,
      margin: [0, 0, 0, 10],
      alignment: 'center'
    };
  }

  public headerDinamic(data) {
    let listaTemp = []

    listaTemp.push({image: `data:image/jpeg;base64, ${data.logo}`, width: 150,  height: 100})

    if (data.universidad) {
      listaTemp.push({text: data.universidad,})
    }

    if (data.nit_universidad) {
      listaTemp.push({text: data.nit_universidad})
    }

    if (data.texto_resol) {
      listaTemp.push({text: data.texto_resol,  noWrap: true})
    }

    if (data.minedu) {
      listaTemp.push({text: data.minedu,  noWrap: true})
    }

    if (data.direccion_universidad) {
      listaTemp.push({text: data.direccion_universidad})
    }
    if (data.contacto) {
      listaTemp.push({text: data.contacto})
    }
    if (data.ciudad_entidad) {
      listaTemp.push({text: data.ciudad_entidad})
    }
    if (data.urlpage) {
      listaTemp.push({text: data.urlpage})
    }
    return listaTemp;
  }



  public async compress(pdfs: any[]) {

    const zip = new JSZip();
    await pdfs.forEach((fileItem) => {

      zip.file(fileItem.filename, fileItem.data);
    });
    return zip.generateAsync({type: 'base64'})
    .then(function(content) {
        // see FileSaver.js
        return content;
    });
  }


}



// WEBPACK FOOTER //
// ./src/app/shared/services/create-pdf.service.ts